<template>
  <li>
    <a
      :class="onItemClick ? 'cursor-pointer' : ''"
      @click="onClick"
    >
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  name: 'TrDropdownItem',
  props: {
    onItemClick: {
      required: false,
      type: Function
    },
    classes: {
      required: false,
      type: String
    }
  },
  methods: {
    onClick() {
      if (this.$el && this.$el.closest('.dropdown')) {
        this.$el.closest('.dropdown').classList.remove('open');
      }

      if (this.onItemClick) {
        this.onItemClick();
      }
    }
  }
};
</script>